import { useState } from 'react';
import { Text, Icon, TwButton as Button } from "@ui-component-library";
import { DynamicModal } from "@components/DynamicModal";
import { KYCStartPageProps } from './KYC.types';
import { kycPreferences } from '@vb-django/api/services/user';
import { useUserDataStore } from '../store/UserDataStore';

export const KYCStartPage = ({ startPageKYCModal, setStartPageKYCModal, setOpenModal }: KYCStartPageProps) => {
    const [isDismissing, setIsDismissing] = useState(false);
    const { setKyc } = useUserDataStore();

    const handleSkip = async () => {
        setIsDismissing(true);
        const response = await kycPreferences({ hasDismissedKyc: true });
        setIsDismissing(false);
        if (response.ok) {
            setOpenModal(false);
            setStartPageKYCModal(false);
            setKyc({ hasDismissedKyc: true, hasCompletedKyc: false });
        } else {
            console.error('Failed to submit has dismissed kyc');
        }
    };

    return (
        <DynamicModal
            isOpen={startPageKYCModal}
            onClose={() => setStartPageKYCModal(false)}
            bp={{ sm: "drawer", lg: "dialog" }}
            dialogSize="medium"
            showDivider
        >
            <DynamicModal.Header>
                <Icon name="TreebulaIcon" size="xlarge" />
            </DynamicModal.Header>
            <DynamicModal.Content>
                <div className="flex flex-col gap-2 items-start self-stretch md:h-full md:justify-center">
                    <Text variant="text-lg/leading-normal/medium" className='my-2'>Hjälp oss anpassa din upplevelse</Text>
                    <Text variant="text-sm/leading-normal/normal">
                        Dina svar hjälper oss att förbättra din upplevelse.
                    </Text>
                    <div className='flex flex-col gap-8 p-4'>
                        <div className="flex">
                            <Icon name="LightbulbSimple" size="large" className="mr-3" />
                            <Text variant="text-sm/leading-normal/normal">
                                Få personliga rekommenadationer
                            </Text>
                        </div>
                        <div className="flex">
                            <Icon name="Sliders" size="large" className="mr-3" />
                            <Text variant="text-sm/leading-normal/normal">Visa relevant innehåll</Text>
                        </div>
                        <div className="flex">
                            <Icon name="CookieSimple" size="large" className="mr-3" />
                            <Text variant="text-sm/leading-normal/normal">För att ge dig bättre tjänster analyserar vi hur du interagerar med våra produkter</Text>
                        </div>
                    </div> 
                        <Text variant="text-xs/leading-normal/normal" className="mb-2 md:text-sm mt-4 text-[#737373]">
                            Du kan använda Treebula som vanligt och svara på frågorna senare.
                        </Text>
                </div>
            </DynamicModal.Content>
            <DynamicModal.Footer>
            <Button variant='tertiary' className="w-full" onClick={handleSkip} disabled={isDismissing}>
                    {isDismissing ? (
                        <div className="flex items-center justify-center gap-2">
                            <div className="h-4 w-4 animate-spin rounded-full border-2 border-solid border-white-50 border-t-transparent" />
                            <span>Hoppar över...</span>
                        </div>
                    ) : (
                        'Nej, hoppa över'
                    )}
                </Button>
                <Button variant="primary" className="w-full" onClick={() => { setOpenModal(true); setStartPageKYCModal(false); }} disabled={isDismissing}>Fortsätt</Button>
                
            </DynamicModal.Footer>

        </DynamicModal>
    )
}
